export const inr = (n, opts = {}) =>
  new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: opts.decimals ?? 2,
    maximumFractionDigits: opts.decimals ?? 2,
  }).format(Number(n || 0));

export const money = (n, opts = {}) => `₹${inr(n, opts)}`;

export const compactInr = (n) => {
  const v = Math.abs(Number(n || 0));
  const sign = Number(n || 0) < 0 ? "-" : "";
  if (v >= 1e7) return `${sign}₹${(v / 1e7).toFixed(2)} Cr`;
  if (v >= 1e5) return `${sign}₹${(v / 1e5).toFixed(2)} L`;
  if (v >= 1e3) return `${sign}₹${(v / 1e3).toFixed(1)}k`;
  return `${sign}₹${v.toFixed(0)}`;
};

export const today = () => new Date().toISOString().slice(0, 10);
export const thisMonth = () => new Date().toISOString().slice(0, 7);

export const fmtDate = (d) => {
  if (!d) return "—";
  const dt = new Date(d);
  if (Number.isNaN(dt.getTime())) return d;
  return dt.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

export const GST_RATES = [0, 0.25, 3, 5, 12, 18, 28];
